import '@src/styles/cardOrder/orderSummary.scss';
import { CustomImage, Text } from '@src/components';
import OrderSummaryInformation from './OrderSummaryInformation';
import CardDetailInformation from './CardDetailInformation';
import iconBack from '@src/assets/icons/icon-back.svg';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { cardOrdersUpdate, prevStep } from '@src/store/slice/cardOrderSlice';
import { useCallback, useEffect, useState, useMemo } from 'react';
import { handleAuthStatus, isCreditCardUser, dataLayer } from '@src/utils/utils';
import { VouIdCode } from '@src/store/enums';
import { getCustomerVouListForGift } from '@src/store/slice/customerSlice';

const OrderSummary = () => {
  const dispatch = useDispatch();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { currentCardOrder, cardOrderPopupDigital } = useSelector((state) => state?.cardOrder);
  const { customerVou, selectedCustomer } = useSelector((state) => state?.customer);
  const { userAuthorizationStatus, userAuthorizationGiftStatus, userAuthorizationMarketStatus } =
    useSelector((state) => state?.user);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const userAuthorizationStatusForType = useMemo(() => {
    if (currentCardOrder?.vouId === VouIdCode.Market) return userAuthorizationMarketStatus;
    if (currentCardOrder?.vouId === VouIdCode.Compliments) return userAuthorizationGiftStatus;
    return userAuthorizationStatus;
  }, [
    currentCardOrder?.vouId,
    userAuthorizationStatus,
    userAuthorizationGiftStatus,
    userAuthorizationMarketStatus,
  ]);

  const handleOrderApproval = useCallback(async () => {
    setButtonLoading(true);
    const body = { ...currentCardOrder };

    const hasApproval = hasAuthorization(
      userAuthorizationStatusForType,
      'ApprovalAuthorizationGroup',
    );
    const hasPayment = hasAuthorization(
      userAuthorizationStatusForType,
      'PaymentAuthorizationGroup',
    );
    const isCreditCard = isCreditCardUser(customerVou);
    const totalPrice = currentCardOrder?.totalPrice || 0;

    let custPamId = customerVou?.pamId;
    if (currentCardOrder?.vouId === VouIdCode.Compliments) {
      const giftCustomerInfo = await dispatch(
        getCustomerVouListForGift({
          customerId: selectedCustomer?.customerId,
          vouId: VouIdCode.Compliments,
        }),
      );
      if (giftCustomerInfo?.payload?.data[0]?.pamId) {
        custPamId = giftCustomerInfo?.payload?.data[0]?.pamId;
      }
    }
    if (!hasApproval || !hasPayment) {
      handleAuthorization(body, isCreditCard, totalPrice, custPamId);
    } else {
      handleApprovedOrder(body, isCreditCard, custPamId);
    }
    await dispatch(cardOrdersUpdate(body));
    logOrderSummary(body);
    setButtonLoading(false);
  }, [currentCardOrder, dispatch, customerVou, userAuthorizationStatusForType]);

  function hasAuthorization(authorizationStatus, group) {
    return handleAuthStatus(authorizationStatus || [], group);
  }

  function handleAuthorization(body, isCreditCard, totalPrice, custPamId) {
    if (isCreditCard) {
      body.orderStatus = totalPrice > 0 ? 20 : 90;
      body.sendMail = totalPrice === 0;
    } else {
      body.orderStatus = 90;
      body.sendMail = true;
      body.paymentType = custPamId;
    }
  }

  function handleApprovedOrder(body, isCreditCard, custPamId) {
    body.orderStatus = 15;
    body.sendMail = true;
    body.pendingApproval = true;
    if (!isCreditCard) {
      body.paymentType = custPamId;
    }
  }

  function logOrderSummary(body) {
    dataLayer(
      'kart_siparis_özeti',
      body?.cardType === 0 ? 'Fiziksel Kart' : 'Dijital Kart',
      cardOrderPopupDigital ? 'Pop up - Dijital Kart Seçin' : '',
    );
  }
  return (
    <div className="card-order-summary-content">
      <OrderSummaryInformation />

      <CardDetailInformation />

      <div className="step-btn-container-summary">
        <Button
          id="cardOrders-orderSummary-main-back-btn"
          className="back-btn"
          onClick={() => dispatch(prevStep())}
        >
          <CustomImage src={iconBack} />
          <Text t="turnBack" />
        </Button>
        <Button
          id="cardOrders-orderSummary-main-next-btn"
          className="next-btn"
          onClick={handleOrderApproval}
          loading={buttonLoading}
        >
          <Text t="continue" />
        </Button>
      </div>
    </div>
  );
};

export default OrderSummary;
